<template>
  <el-dialog :title="getTitle" top="50px" :visible.sync="dailogShow" width="80%" :close-on-click-modal="false" :before-close="handleClose" append-to-body @open="handleOpen">
    <el-form ref="postForm" :model="postForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-position="right">
      <el-row :gutter="20">
        <el-col :span="8" :offset="16">
          <el-form-item prop="stockInCode" label="采购编号" style="margin-bottom: 0px">
            <el-input v-model="postForm.stockInCode" maxlength="50" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">试剂耗材信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="guigeQty" label="规格">
            <el-input-number v-model="postForm.guigeQty" placeholder="规格(数量)" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="guigeUnit" label="">
            <el-input v-model="postForm.guigeUnit" maxlength="10" placeholder="规格(单位)" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="caigouZongjia" label="采购总价">
            <el-input-number v-model="postForm.caigouZongjia" placeholder="采购总价" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="shenqingQty" label="申请数量">
            <el-input-number v-model="postForm.shenqingQty" placeholder="申请数量" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shenqingUnit" label="购买单位">
            <el-input v-model="postForm.shenqingUnit" maxlength="10" placeholder="购买单位" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="caigouDanjia" label="采购单价">
            <el-input-number v-model="postForm.caigouDanjia" placeholder="采购单价" disabled :controls="false" :precision="2" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">课题信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="keshi" label="科室">
            <el-input v-model="postForm.keshi" maxlength="50" placeholder="科室" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="ketiFzrUserId" label="课题负责人">
            <el-select v-model="postForm.ketiFzrUserId" placeholder="课题负责人" disabled>
              <el-option
                v-for="item in ketiMemberList"
                :key="item.userKey"
                :label="item.userName"
                :value="item.userKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item prop="ketiMingcheng" label="课题名称">
            <el-input v-model="postForm.ketiMingcheng" maxlength="50" placeholder="课题名称" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="ketiBianhao" label="课题编号">
            <el-input v-model="postForm.ketiBianhao" maxlength="50" placeholder="课题编号" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="shiyanMingcheng" label="实验名称">
            <el-input v-model="postForm.shiyanMingcheng" maxlength="50" placeholder="实验名称" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="shiyanBianhao" label="实验编号">
            <el-input v-model="postForm.shiyanBianhao" maxlength="50" placeholder="实验编号" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="yongtu" label="用途">
            <el-input v-model="postForm.yongtu" maxlength="50" placeholder="用途" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="jingfeiLaiyuan" label="经费来源">
            <el-input v-model="postForm.jingfeiLaiyuan" maxlength="50" placeholder="经费来源" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="jingfeiKahao" label="经费卡号">
            <el-input v-model="postForm.jingfeiKahao" maxlength="50" placeholder="经费卡号" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider content-position="left"><span style="color:#409EFF">报销信息</span></el-divider>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="kemuleibie" label="科目类别">
            <el-input v-model="postForm.kemuleibie" maxlength="50" placeholder="科目类别" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="kaipiaoRiqi" label="开票日期">
            <el-date-picker
              v-model="postForm.kaipiaoRiqi"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="fapiaohao" label="发票号">
            <el-input v-model="postForm.fapiaohao" maxlength="50" placeholder="发票号" />
          </el-form-item>
        </el-col>

      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item prop="baoxiaozheUserId" label="报销者">
            <el-select v-model="postForm.baoxiaozheUserId" disabled placeholder="报销者" clearable>
              <el-option
                v-for="item in ketiMemberList"
                :key="item.userKey"
                :label="item.userName"
                :value="item.userKey"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="baoxiaoRiqi" label="报销日期">
            <el-date-picker
              v-model="postForm.baoxiaoRiqi"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave()">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
// import { parseTime } from '@/utils/index'
export default {
  components: {
  },
  props: {
    entityId: { type: Number, default: null }
  },
  data() {
    return {
      dailogShow: false,
      allComboxData: [],
      postForm: {},
      ketiMemberList: [],

      rules: {

        kemuleibie: [{ required: true, message: '请输入科目类别', trigger: 'change,blur' }],
        kaipiaoRiqi: [{ required: true, message: '请输入开票日期', trigger: 'change,blur' }],
        fapiaohao: [{ required: true, message: '请输入发票号', trigger: 'change,blur' }],
        baoxiaoRiqi: [{ required: true, message: '请输入报销日期', trigger: 'change,blur' }]

      }

    }
  },
  /** 计算 */
  computed: {
    isEdit() {
      return !!this.entityId
    },
    getTitle() {
      return (this.entityId ? '报销' : '报销')
    }

  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    pathReq.getComboxDatasByIdArray('D99;F05').then(res => {
      that.allComboxData = res.data.result
    })
    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm('api/services/app/Com/GetKetizuMember').then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter((item) => {
        return item.typeId === typeId
      })
    },
    show() {
      this.dailogShow = true
    },
    handleClose() {
      this.$refs['postForm'].resetFields()
      this.dailogShow = false
    },
    handleOpen() {
      const that = this
      const path = '/api/services/app/zy02/GetDataBaoxiao?Id=' + this.entityId

      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getNoParams(path).then(res => {
        that.postForm = res.data.result
        if (that.postForm.shenqingQty && that.postForm.caigouDanjia) {
          that.postForm.caigouZongjia = that.postForm.shenqingQty * that.postForm.caigouDanjia
        } else {
          that.postForm.caigouZongjia = undefined
        }
      }).then(_ => {
        loading.close()
      })
    },

    /** 保存
     */
    handleSave() {
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const that = this
          var path = '/api/services/app/zy02/DoBaoxiao'

          const postForm = that.postForm

          pathReq.dataUpdate(path, postForm).then(res => {
            that.$message.success('保存成功')
            this.$emit('save-success')
          }).then(_ => {
            that.$refs['postForm'].resetFields()
            this.dailogShow = false
          })
        }
      })
    }

  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
</style>
